import { Button, Card, Input, Typography } from "@arco-design/web-react";
import { useState } from "react";

import { resetCurrentAuthUserPassword, useCurrentAuthUser } from "..";

const { Paragraph, Text, Title } = Typography;

/** 当前管理员重置自身登录密码页面。 */
export function ResetPasswordPage() {
  const currentUserQuery = useCurrentAuthUser();
  const currentUser = currentUserQuery.data;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  /** 提交当前登录管理员的新密码。 */
  async function handleSubmit() {
    setMessage("");
    setErrorMessage("");
    if (!currentUser) {
      setErrorMessage("当前登录态不可用，请重新登录。");
      return;
    }
    if (password.length < 6) {
      setErrorMessage("新密码至少 6 位。");
      return;
    }
    if (password !== confirmPassword) {
      setErrorMessage("两次输入的密码不一致。");
      return;
    }
    setSubmitting(true);
    try {
      await resetCurrentAuthUserPassword(currentUser.id, { password });
      setPassword("");
      setConfirmPassword("");
      setMessage("密码已重置，请使用新密码登录。");
    } catch {
      setErrorMessage("重置密码失败，请确认当前账号具备管理员权限。");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section style={{ maxWidth: 720 }}>
      <Card style={{ borderRadius: 8 }}>
        <Title heading={5} style={{ marginTop: 0, letterSpacing: 0 }}>
          重置密码
        </Title>
        <Paragraph type="secondary" style={{ marginTop: 0 }}>
          {currentUser?.displayName ?? "当前登录用户"}
        </Paragraph>
        {message ? <AuthInlineMessage tone="success" message={message} /> : null}
        {errorMessage ? <AuthInlineMessage tone="error" message={errorMessage} /> : null}
        <div style={{ display: "grid", gap: 14, maxWidth: 420 }}>
          <label style={{ display: "grid", gap: 6 }}>
            <Text>新密码</Text>
            <Input.Password
              aria-label="新密码"
              value={password}
              autoComplete="new-password"
              onChange={setPassword}
            />
          </label>
          <label style={{ display: "grid", gap: 6 }}>
            <Text>确认密码</Text>
            <Input.Password
              aria-label="确认密码"
              value={confirmPassword}
              autoComplete="new-password"
              onChange={setConfirmPassword}
            />
          </label>
          <Button
            type="primary"
            loading={submitting}
            disabled={currentUserQuery.isLoading}
            onClick={() => void handleSubmit()}
          >
            确认重置
          </Button>
        </div>
      </Card>
    </section>
  );
}

/** 认证页内提示。 */
function AuthInlineMessage({ tone, message }: { tone: "success" | "error"; message: string }) {
  return (
    <div
      role={tone === "error" ? "alert" : "status"}
      style={{
        border: `1px solid ${tone === "error" ? "#ffccc7" : "#b7eb8f"}`,
        borderRadius: 8,
        background: tone === "error" ? "#fff2f0" : "#f6ffed",
        color: tone === "error" ? "#b42318" : "#237804",
        marginBottom: 14,
        padding: "9px 11px",
        fontSize: 13,
        lineHeight: 1.45,
      }}
    >
      {message}
    </div>
  );
}
